import { render, staticRenderFns } from "./CallUpdateProjectSettings.vue?vue&type=template&id=417b042d"
import script from "./CallUpdateProjectSettings.vue?vue&type=script&lang=js"
export * from "./CallUpdateProjectSettings.vue?vue&type=script&lang=js"
import style0 from "./CallUpdateProjectSettings.vue?vue&type=style&index=0&id=417b042d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports